import React, { useState, useEffect } from 'react';
import { CheckCircle, XCircle, AlertCircle } from 'lucide-react';
import { apiService, getApiBaseUrl } from '../services/api';

const ApiStatus = () => {
  const [status, setStatus] = useState('checking');
  const [apiUrl, setApiUrl] = useState('');

  useEffect(() => {
    setApiUrl(getApiBaseUrl());
    checkApiHealth();
  }, []);

  const checkApiHealth = async () => {
    try {
      await apiService.healthCheck();
      setStatus('connected');
    } catch (error) {
      setStatus('error');
    }
  };

  const getStatusIcon = () => {
    switch (status) {
      case 'connected':
        return <CheckCircle className="h-4 w-4 text-success-500" />;
      case 'error':
        return <XCircle className="h-4 w-4 text-error-500" />;
      default:
        return <AlertCircle className="h-4 w-4 text-warning-500" />;
    }
  };

  const getStatusText = () => {
    switch (status) {
      case 'connected':
        return 'Connected';
      case 'error':
        return 'Connection Error';
      default:
        return 'Checking...';
    }
  };

  const getStatusColor = () => {
    switch (status) {
      case 'connected':
        return 'text-success-600 bg-success-50';
      case 'error':
        return 'text-error-600 bg-error-50';
      default:
        return 'text-warning-600 bg-warning-50';
    }
  };

  return (
    <div className="flex items-center text-xs text-gray-500">
      <div className="flex items-center mr-2">
        {getStatusIcon()}
        <span className={`ml-1 px-2 py-1 rounded-full text-xs font-medium ${getStatusColor()}`}>
          {getStatusText()}
        </span>
      </div>
      <span className="truncate max-w-48">
        API: {apiUrl}
      </span>
    </div>
  );
};

export default ApiStatus;